'use client';

import React, { Suspense } from 'react';
import { useRouter } from 'next/navigation';
import AgencyQuickPostRoadmapContent from '@/doi-tac-module/components/quy-trinh/agency-quick-post-roadmap-content';
import { GlobalBrandedLoader } from '@/doi-tac-module/components/global-branded-loader';

export default function PublicQuickPostRoadmapPage() {
    const router = useRouter();

    return (
        <Suspense fallback={<GlobalBrandedLoader forceShow={true} />}>
            <AgencyQuickPostRoadmapContent 
                onBack={() => router.push('/quy-trinh')} 
                isPublic={true}
            />
        </Suspense>
    );
}
